import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { PickerFormControl, } from '../EntityPicker/PickerFormControl';
export function FormMemberPicker({ name, validation, value: fieldValue, onChange: fieldOnChange, ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, render: ({ field: { onChange, value }, fieldState: { error } }) => (_jsx(PickerFormControl.MemberPicker, { ...rest, name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : value, onChange: value => {
                onChange(value);
                if (typeof fieldOnChange === 'function') {
                    fieldOnChange(value);
                }
            } }, void 0)) }, void 0));
}
//# sourceMappingURL=FormMemberPicker.js.map